import React, { useState, useEffect } from "react";
import OrderListPage from "pages/orders/OrderListPage";
import { TravelProvider } from "misc/TravelContext";
import DeliveryPage from "pages/delivery/DeliveryPage";
import DeliveredRoutesPage from "pages/routes/DeliveredRoutesPage";
import DriverDetailsPage from "pages/drivers/DriverDetailsPage";
import { AppBar, Toolbar, Typography, Button, Collapse, IconButton, Menu, MenuItem, Switch, FormControlLabel, FormGroup, Box } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import LoginPage from "pages/LoginPage";
import RoutesCreationPage from "pages/routesAdmin/routesCreationPage";
import RoutesAdminPage from "pages/routesAdmin/routesAminPage";
import UserDetailsPage from "pages/users/UserDetailsPage";
import { getUser } from "api/users";
import { User } from "typings/models";

const App: React.FC = () => {
    const [step, setStep] = useState<string>("orderList");
    const [openMenu, setOpenMenu] = useState(false);
    const [auth, setAuth] = useState(true);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    let storedToken = localStorage.getItem('token');
    const [token, setToken] = useState<string | null>(storedToken);
    const [user, setUser] = useState<User | null>(null);



    const handleToggleMenu = () => {
        setOpenMenu(!openMenu);
    };

    const handleNextStep = () => {
        setStep("delivery");
    };

    const handleViewDeliveredRoutes = () => {
        setStep("deliveredRoutes");
        setOpenMenu(false);
    };

    const handleViewUserDetails = () => {
        setStep("userDetails");
        setOpenMenu(false);
    };

    const handleViewDriverDetails = () => {
        setStep("driverDetails");
        setOpenMenu(false);
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAuth(event.target.checked);
    };

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        setToken(null);
        localStorage.removeItem('token');
        setOpenMenu(false);
    };

    const handleViewRoutesAdmin = () => {
        setStep("routesCreate");
        setOpenMenu(false);
    };

    const handleAdminRoutes = () => {
        setStep("routesAdmin");
        setOpenMenu(false);
    };

    const handleViewCurrentRoute = () => {
        setStep("orderList");
        setOpenMenu(false);
    };

    const stepTitles = {
        orderList: "Pedidos",
        delivery: "Entregas",
        deliveredRoutes: "Mis Rutas",
        driverDetails: "Detalles del Conductor",
        routesAdmin: "Administrar Rutas",
        routesCreate: "Crear Ruta" ,
        userDetails: "Detalles del Usuario"
    }

    useEffect(() => {
        if (token) {
            getUser().then((user) => {
                setUser(user);
                if (user.role === "driver") {
                    setStep("orderList");
                } else if (user.role === "route_admin") {   
                    setStep("routesCreate");
                }
            })
        }
    }, []);



    return (
        
        <TravelProvider>
            {!token && <LoginPage setToken={setToken} setUser={setUser} setStep={setStep} />}
            {token && <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            onClick={handleToggleMenu}
                            sx={{ mr: 2 }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            {stepTitles[step as keyof typeof stepTitles]}
                        </Typography>
                        {false && (
                            <div>
                                <IconButton
                                    size="large"
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleToggleMenu}
                                    color="inherit"
                                >
                                    <AccountCircle />
                                </IconButton>
                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorEl}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}
                                >
                                    <MenuItem onClick={handleClose}>Profile</MenuItem>
                                    <MenuItem onClick={handleClose}>My account</MenuItem>
                                </Menu>
                            </div>
                        )}
                    </Toolbar>
                    <Collapse in={openMenu}>
                    {user?.role === "driver" && <><Button color="inherit" onClick={
                            handleViewCurrentRoute
                        }>Ruta Actual</Button>
                        <br/>
                        </>}  
                        <Button color="inherit" onClick={
                            handleViewUserDetails
                            
                        }>Mi Perfil</Button>
                        <br/>
                        {user?.role === "driver" && <><Button color="inherit" onClick={
                            handleViewDeliveredRoutes
                        }>Mis Rutas</Button>
                        <br/>
                        </>}  
                        {user?.role === "route_admin" && <><Button color="inherit" onClick={
                            handleAdminRoutes
                        }>Administrar Rutas</Button>
                        <br/>
                        </>}
                        {user?.role === "route_admin" && <><Button color="inherit" onClick={
                            handleViewRoutesAdmin
                        }>Crear Ruta</Button>
                        <br/>
                        </>}
                        <Button color="inherit" onClick={
                            handleLogout    
                        }>Cerrar sesión</Button>
                        <br/>   

                    </Collapse>
                </AppBar>

                {step === "orderList" && <OrderListPage setNextStep={handleNextStep} setStep={setStep} />}
                {step === "delivery" && <DeliveryPage setStep={setStep} />}
                {step === "deliveredRoutes" && <DeliveredRoutesPage setStep={setStep}/>}
                {step === "driverDetails" && <DriverDetailsPage />}
                {step === "routesCreate" && <RoutesCreationPage />}
                {step === "routesAdmin" && <RoutesAdminPage />}
                {step === "userDetails" && <UserDetailsPage />}
            </Box>}

        </TravelProvider>
        
    );
};

export default App;
